import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { UserAuthGuard } from './core/guards/user-auth.guard';

const routes: Routes = [

  {
    path: "",
    loadChildren: () => import('./modules/home/home.module')
    .then(m => m.HomeModule)
  },

  {
    path: "our-branches",
    loadChildren: () => import('./modules/our-branches/our-branches.module')
    .then(m => m.OurBranchesModule)
  },

  {
    path: "cart",
    loadChildren: () => import('./modules/cart/cart.module')
    .then(m => m.CartModule)
  },

  {
    path: "auth",
    loadChildren: () => import('./modules/authentication/authentication.module')
    .then(m => m.AuthenticationModule)
  },

  {
    path: "about-qaysar-pizza",
    loadChildren: () => import('./modules/about-qaysar-pizza/about-qaysar-pizza.module')
    .then(m => m.AboutQaysarPizzaModule)
  },

  {
    path: "privacy-policy",
    loadChildren: () => import('./modules/privacy-policy/privacy-policy.module')
    .then(m => m.PrivacyPolicyModule)
  },

  {
    path: "terms-and-conditions",
    loadChildren: () => import('./modules/terms-and-conditions/terms-and-conditions.module')
    .then(m => m.TermsAndConditionsModule)
  },

  {
    path: "have-a-complaint",
    loadChildren: () => import('./modules/have-a-complaint/have-a-complaint.module')
    .then(m => m.HaveAComplaintModule)
  },
  
  {
    path: "careers",
    loadChildren: () => import('./modules/careers/careers.module')
    .then(m => m.CareersModule)
  },

  {
    path: "profile",
    // resolve: { data: UserResolver},
    canActivate: [UserAuthGuard],
    loadChildren: () => import('./modules/profile/profile.module')
    .then(m => m.ProfileModule)
  },

  {
    path: "refund-policy",
    loadChildren: () => import('./modules/refund/refund.module')
    .then(m => m.RefundModule)
  },

  {
    path: "cancellation-policy",
    loadChildren: () => import('./modules/cancelation-policy/cancelation-policy.module')
    .then(m => m.CancelationPolicyModule)
  },

  {
    path: "delivery_policy_&_method",
    loadChildren: () => import('./modules/delivery-policy-and-method/delivery-policy-and-method.module')
    .then(m => m.DeliveryPolicyAndMethodModule)
  },
  
  {
    path: "**",
    component: PageNotFoundComponent
  }

];



@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})




export class AppRoutingModule { }
